export default __webpack_public_path__ + "static/media/thumbnail.2bee8f15.png";